module.exports = __webpack_public_path__ + "img/imags_m_cardimg_01.c56b2b8.png";